import React from 'react';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { convertUTCDateToLocalDate } from 'helpers/date';


const rewardStatus = ['', 'Pending', 'Complete', 'Cancel', 'Expired'];

const CustomerRewardRow = ({reward}) => {
  const {
    transaction_id,
    point_amount,
    status,
    created_at,
    expiration_date,
    extension_attributes: {
      title
    }
  } = reward;

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell component="th" scope="row" width="100px">
          <strong className="px-5">{transaction_id}</strong>
        </TableCell>
        <TableCell>{title}</TableCell>
        <TableCell align="center">{point_amount}</TableCell>
        <TableCell>{rewardStatus[status]}</TableCell>
        <TableCell>
          {convertUTCDateToLocalDate(created_at).toLocaleString(
            'en-US',
            {
              dateStyle: 'medium',
              timeStyle: 'short'
            })
          }
        </TableCell>
        <TableCell>
          {expiration_date ?
            convertUTCDateToLocalDate(expiration_date).toLocaleString(
              'en-US',
              {
                dateStyle: 'medium',
                timeStyle: 'short'
              })
            : '---'
          }
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerRewardRow;
